import { IdentityHostname } from './identity';
import type { Environment } from './interface';

export const staging: Environment = {
  apiBusinessGqlUrl: 'https://staging-business-center.pipelinersales.com/api/business/graphql',
  apiCustomerGqlOrigin: `https://staging-customer-portal.${IdentityHostname}`,
  apiUserGqlUrl: `https://staging-api.${IdentityHostname}/api/user/graphql`,
  apiSchedulerGqlUrl: 'https://staging-api.pipelinersales.com/api/scheduler/public/graphql',
  apiOnlineFormGqlUrl: 'https://staging-api.pipelinersales.com/api/online-form/public/graphql',
  apiPublicGqlUrl: 'https://staging-api.pipelinersales.com/api/public/graphql',
  businessCenterUrl: 'https://staging-business-center.pipelinersales.com',
  customerPortalUrl: 'https://staging-customer-portal.pipelinersales.com',
  partnerPortalUrl: 'https://staging-partner-portal.pipelinersales.com',
  crmUrl: `https://staging-crm.${IdentityHostname}`,
  schedulerUrl: `https://staging-scheduler.pipelinersales.com`,
  signUpUrl: 'https://staging-wordpress.pipelinersales.com/crm/free-trial/',
  ssoUrl: 'https://staging-accounts.pipelinersales.com',
  formsUrl: `https://staging-forms.pipelinersales.com`,
};
